import { Component, OnInit, Inject } from '@angular/core';
import { MdInputModule, MdRadioModule, MdDialog, MdDialogRef, MD_DIALOG_DATA, MdSelectModule } from '@angular/material';
import { NgForm, FormControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { ValidationService } from '../../../shared/services/validation.service';
import { PrescriptionsModel } from '../../../models/consultation-process/prescription-selection.model';

@Component({
  templateUrl: 'edit-prescription-popup.component.html',
})

export class EditPrescriptionPopupComponent implements OnInit {

  public klass = 'editPrescriptionPopup';

  public editPrescriptionForm: FormGroup;

  constructor(public dialogRef: MdDialogRef<EditPrescriptionPopupComponent>,
    public formBuilder: FormBuilder,
    @Inject(MD_DIALOG_DATA) public data: PrescriptionsModel) {
    this.createForm();
  }

  ngOnInit() {
    this.editPrescriptionForm.controls['type'].setValue(this.data.isWeekType ? 'week' : 'quantity');
    this.editPrescriptionForm.controls['quantity'].setValue(this.data.quantity);
  }

  createForm() {
    this.editPrescriptionForm = this.formBuilder.group({
        type: [null, [Validators.required]],
        quantity: [null, [Validators.required, ValidationService.isValidNumber1To999]]
    });
  }

// //   onDateChange(event) {
// //     ValidationService.validationDate(this.newDiseaseForm.controls['AdministeredDate'], event);
// //     this.CalculateExpiredDate();
// //   }

//   checkValueRange() {
//     if (this.editPrescriptionForm.controls['Amount'].value < 1 || this.editPrescriptionForm.controls['Amount'].value > 999) {
//       return 'Invalid. Value is between 1 and 999';
//     }
//   }

  onSubmit() {
    if (this.editPrescriptionForm.valid) {
      const data = {
        type: this.editPrescriptionForm.controls['type'].value,
        quantity: this.editPrescriptionForm.controls['quantity'].value
      };
      this.dialogRef.close(data);
    }
  }

  onCloseDialog() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/select-prescriptions/edit-prescription-popup.component.ts